import trackCustom from './track-custom';
import trackWebVitals from './track-web-vitals';
import trackNavigationTiming from './track-navigation-timing';


/**
 * @callback sendClientEvent
 * @see
 * {@link https://github.com/buzzfeed/mono/tree/master/packages/frontend/client-event-tracking}
 */

/**
 * This function is provided as a convenience for tracking all available performance events. This
 * include custom metrics, web vitals, and navigation timing.
 * @param  {sendClientEvent}
 * @param  {Object} [options={}] - Configuration object
 * @param  {Array} [options.layers=[]] - An array containing an object or a function that returns an
 * object representing fields to be sent to CET.
 * @param  {Number} [options.sample_rate=0.1] - Rate at which to sample event requests (between 0 and 1)
 * @param  {Object} [options.profiling={}] - Options to pass to the longtask longest frame metric
 * including `ignore_pattern` and event `limit`.
 */
const trackPerformance = (sendClientEvent,
  {
    layers = [],
    sample_rate = 0.1,
    profiling = {},
  } = {}
) => {
  const options = {
    layers,
    sample_rate,
  };

  trackWebVitals(sendClientEvent, options);
  trackNavigationTiming(sendClientEvent, options);
  trackCustom(sendClientEvent, { ...options, profiling });
};

export default trackPerformance;
